import { ResignTermsOfServiceMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const resignTermsOfServiceHandler =
  graphql.mutation<ResignTermsOfServiceMutation>(
    "resignTermsOfService",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: { resignTermsOfService: true },
      });
    }
  );
